/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";
import { useSearch } from "@packages/framework";
import { useEffect, useState } from "react";

import { AuthMainFlow } from "./AuthMainFlow.emotion";
import type { AuthFlow, AuthFlowProps, AuthProps } from "./AuthTypes.emotion";

export type SimplifiedAuthProps = {
  onFlowChange: (flow: AuthFlow) => void;
  onAuth: AuthFlowProps["onAuth"];
  allowedMethods?: AuthProps["allowedMethods"];
  className?: string;
  legalCSS?: Interpolation;
};

export const SimplifiedAuth = ({
  onFlowChange,
  allowedMethods = ["email", "phone", "apple", "google"],
  onAuth,
  className = "",
  legalCSS,
}: SimplifiedAuthProps) => {
  const search = useSearch();
  const [flow, setFlow] = useState<AuthFlow>(
    (search.get("flow") as AuthFlow) || "main",
  );

  useEffect(() => {
    if (flow !== "main") {
      onFlowChange(flow);
    }
  }, [flow]);

  return (
    <AuthMainFlow
      flow={flow}
      setFlow={setFlow}
      onAuth={onAuth}
      allowedMethods={allowedMethods}
      className={className}
      legalCSS={legalCSS}
    />
  );
};
